import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { zIndex, colors } from '../../../styles';
import StyledButton from '../../button/button-new.styles';
var defaultStyles = function defaultStyles(_ref) {
  var isInverse = _ref.isInverse;
  return /*#__PURE__*/css("align-items:center;cursor:pointer;width:auto;flex-shrink:0;z-index:", zIndex.zIndex_2, ";& svg{path{fill:", isInverse ? "".concat(colors.white) : 'currentColor', ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var StyledTooltipCloseButton = /*#__PURE__*/_styled(StyledButton, process.env.NODE_ENV === "production" ? {
  target: "e95pbhu0"
} : {
  target: "e95pbhu0",
  label: "StyledTooltipCloseButton"
})(defaultStyles);
export default StyledTooltipCloseButton;